import { render, staticRenderFns } from "./orderTablelist.vue?vue&type=template&id=3f18c82e"
import script from "./orderTablelist.vue?vue&type=script&lang=js"
export * from "./orderTablelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports